module.exports = __webpack_public_path__ + "static/media/po-undercarriage-7.07f97069.png";